// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__3zkKm","savePackageButton":"ClientWallet_savePackageButton__w3HtC"};